import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { TenantService } from '../../services/tenant/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private router: Router,
    private authService: AuthService,
    private tenantService: TenantService
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const token = this.authService.getAccesToken();
    if (!token) {
      if (state.url.startsWith('/admin')) {
        this.tenantService.clearSlug();
        localStorage.removeItem('user_roles');
      }
      return true;
    }

    const roles = this.authService.getUserRoles();
    if (!roles.length) return true;

    if (roles.includes('super-admin')) {
      this.router.navigate(['/admin/tenants']);
      return false;
    }

    const slug = this.tenantService.getSlug();
    this.router.navigate([slug, 'pools', 'list']);
    return false;
  }

}
